const FORM_GLOBAL_VALIDATION_ERROR = 'خطاهای فرم ارسالی را برطرف کنید';

export default FORM_GLOBAL_VALIDATION_ERROR;
